﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../application"
import { IDisposable } from "../../interfaces/general";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"
import { ComplaintData, Complaint } from "../../models/complaint"
import { ComplaintBase } from "./complaintBase"
import { IsProcessingService } from "../../services/isProcessingService";
import { DialogService } from "../../services/dialogService";
import { LogService } from "../../services/logService";
import { ServiceUtils } from "../../services/serviceBase";
import { AuthorizationService } from "../../services/authorizationService";

@Component({
    module: FIQAssist,
    selector: "complaintEntry",
    templateUrl: "views/complaint.entry.html",
    require: {
        application: "^application",
        base: "^complaintBase"
    }
})
class ProblemEntry implements IComponent {
    @Input() private $router: ng.Router;
    public application: Application;
    private base: ComplaintBase
    private cid: string;

    constructor(
        @Inject() private serviceCaseService: ServiceCaseService,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$element') protected $element: ng.IRootElementService,
        @Inject('$rootRouter') private $rootRouter: angular.Router,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject() private dialogService: DialogService,
        @Inject() private logService: LogService
    ) {
    }

    async $onInit() {
        this.complaintData = <ComplaintData>{
            Content: "",
            createdOn: undefined,
            createdBy: undefined

        }
        var customers = await this.application.customers;
        var cust = customers.length == 1 ? customers[0] : customers.filter(c => c.checked).length == 1 ? customers.filter(c => c.checked).shift() : null;
        if (cust)
            this.cid = cust.key;
        this.base.Title = "I_WANT_TO_ISSUE_A_COMPLAINT";
        this.base.activeMenuItem = 'complaint';
        this.base.isDirty = false;
    }

    $onDestroy() {
        this.base.activeMenuItem = '';
    }

    public contentChanged(value: string) {
        if (this.complaintData.Content != value) {
            this.complaintData.Content = value;
            this.base.isDirty = true;
        }
    }

    public async customerchanged(customerKeys: any[]) {
        var sel = (customerKeys && customerKeys.length > 0) ? customerKeys[0] : undefined;
        if (sel) {
            this.cid = sel;
            if ((await this.application.customers).length > 1)
                this.base.isDirty = true;
        } else {
            this.cid = undefined;
        }
    }

    private complaintData: ComplaintData

    public async save() {
        if (this.validate()) {
            try {
                this.isProcessingService.StartProcessing();
                await this.serviceCaseService.NewComplaint(this.cid, this.complaintData);
                this.base.isDirty = false;
                this.dialogService.showMessageDialog('info', 'THX', 'SAVE_COMPLAINT_THX', { translate: true, onclose: () => this.$rootRouter.navigate(['/Home', {}]) });
            } catch (error) {
                if (ServiceUtils.IsUnauthorizedResponse(error)) {
                    this.base.isDirty = false;
                    return;
                }
                this.application.setSeqUrl(error);
                this.logService.error('ComplaintEntry', 'Error saving complaint', error);
                this.dialogService.showErrorDialog('error', 'ERROR', 'SAVE_COMPLAINT_ERROR', { errorResult: error, translate: true });
            } finally {
                this.isProcessingService.StopProcessing();
            }

        }
    }

    private validate(): boolean {
        var result: boolean = true;
        if (this.complaintData.Content && this.complaintData.Content.length > 0)
            this.base.clearErrorClass(this.$element, 'editcontent');
        else {
            this.base.setErrorClass(this.$element, 'editcontent');
            result = false;
        }
        if (this.cid)
            this.base.clearErrorClass(this.$element, 'editcustomer');
        else {
            this.base.setErrorClass(this.$element, 'editcustomer');
            result = false;
        }
        return result;
    }

    public back() {
        this.base.goHome();
    }
}
